import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

        const jwtToken = localStorage.getItem('jwtToken');
        const sessionId = localStorage.getItem('sessionId');

        const excludedUrls = [
            '/get-random-uid',
            '/save-aes-key',
            '/get-social-url',
            '/sign-in',
            '/verify-otp'
        ];

        const shouldExclude = excludedUrls.some(url => request.url.includes(url));

        if (!shouldExclude && jwtToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${jwtToken}`,
                    'SESSION-ID': sessionId || ''
                }
            });
        }

        return next.handle(request);
    }
}
